var map = {
	"./administracion/biblioteca/biblioteca.module": [
		"./src/app/administracion/biblioteca/biblioteca.module.ts",
		"administracion-biblioteca-biblioteca-module"
	],
	"./administracion/cartera/cartera.module": [
		"./src/app/administracion/cartera/cartera.module.ts",
		"default~administracion-cartera-cartera-module~dashboard-dashboard-module",
		"administracion-cartera-cartera-module"
	],
	"./administracion/configuracion/configuracion.module": [
		"./src/app/administracion/configuracion/configuracion.module.ts",
		"administracion-configuracion-configuracion-module"
	],
	"./administracion/contabilidad/contabilidad.module": [
		"./src/app/administracion/contabilidad/contabilidad.module.ts",
		"default~administracion-contabilidad-contabilidad-module~administracion-garantia-garantia-module",
		"administracion-contabilidad-contabilidad-module"
	],
	"./administracion/garantia/garantia.module": [
		"./src/app/administracion/garantia/garantia.module.ts",
		"default~administracion-contabilidad-contabilidad-module~administracion-garantia-garantia-module",
		"administracion-garantia-garantia-module"
	],
	"./administracion/mantenimiento/mantenimiento.module": [
		"./src/app/administracion/mantenimiento/mantenimiento.module.ts",
		"administracion-mantenimiento-mantenimiento-module"
	],
	"./administracion/panel-control/panel-control.module": [
		"./src/app/administracion/panel-control/panel-control.module.ts",
		"administracion-panel-control-panel-control-module"
	],
	"./administracion/reportes/reportes.module": [
		"./src/app/administracion/reportes/reportes.module.ts",
		"administracion-reportes-reportes-module"
	],
	"./administracion/seguimiento-tarea/seguimiento-tarea.module": [
		"./src/app/administracion/seguimiento-tarea/seguimiento-tarea.module.ts",
		"administracion-seguimiento-tarea-seguimiento-tarea-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"default~administracion-cartera-cartera-module~dashboard-dashboard-module",
		"dashboard-dashboard-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;